import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionSustitutoDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionSustitutoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getEstadoRevisionSustitutoService(): Observable<BodyListResponse<EstadoRevisionSustitutoDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionSustitutoDTO>>(API_URL + '/api/v1/estadoRevisionSustituto/todos');
  }

  guardarEstadoRevisionSustitutoService(estadoRevisionSustitutoDTO: EstadoRevisionSustitutoDTO): Observable<EstadoRevisionSustitutoDTO> {
    return this.http.post<EstadoRevisionSustitutoDTO>(API_URL + '/api/v1/estadoRevisionSustituto', estadoRevisionSustitutoDTO);
  }

  getEstadoRevisionSustitutoPorCodigoRevisionSustitutoService(codigoRevisionSustituto: string): Observable<BodyResponse<EstadoRevisionSustitutoDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionSustitutoDTO>>(API_URL + '/api/v1/estadoRevisionSustituto/' + codigoRevisionSustituto);
  }

  getEstadoRevisionSustitutoPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionSustitutoDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionSustitutoDTO>>(API_URL + '/api/v1/estadoRevisionSustituto/persona/'+codigoPersona);
  }

}
